RivalIQ.module('utils.queryParams', function (queryParams, App, Backbone, Marionette, $, _) {

    'use strict';

    // the default parser will make the searchTerms a number if it is parsable as such. We need it to always be a string.
    queryParams.forceSearchParamsToString = function (parsedParams, searchFieldNames) {
        _.each(_.keys(searchFieldNames), function (searchFieldName) {
            if (!_.isUndefined(parsedParams[searchFieldName])) {
                parsedParams[searchFieldName] = String(parsedParams[searchFieldName]);
            }
        });

        return parsedParams;
    };
});
